export default __webpack_public_path__ + "static/media/CompoundScreen.3e224e3c.gif";